import { Typography } from '@mui/material'

export const FormContactPickerPrint = ({ value, title }) => {
  let valueToShow = value ? value.firstName + ' ' + value.lastName : ''
  if (valueToShow && value.jobTitle) {
    valueToShow += ', ' + value.jobTitle
  }
  if (valueToShow && value.email) {
    valueToShow += ', ' + value.email
  }

  return (
    <Typography style={{ whiteSpace: 'pre-line' }}>{valueToShow}</Typography>
  )
}
